import { Link } from "@StarberryUtils";
import * as React from "react"
import { Button, Container, Form, Row, Col } from 'react-bootstrap';
//import ScrollAnimation from "react-animate-on-scroll";
import { useStaticQuery, graphql } from "gatsby";
import HTMLReactParser from 'html-react-parser';
import "./Contact.scss"
import { GetURL } from "../../common/site/functions"
import BookAViewForm from "../../forms/book-a-viewing-form";
import ValuationFormPage from "../../forms/valuation-form";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import useDeviceMedia from "../../utils/useDeviceMedia";
import ModalTiny from "react-bootstrap/Modal"
import { CloseIcon } from "../../Icons/Icons";

// markup
const NewsStaticContact = () => {
    const { isCustomMin } = useDeviceMedia({ min: "992px" });
    const [modalBookViewformOpen, setBookViewingformOpen] = React.useState(false);
    const data = useStaticQuery(graphql`
    query {
      glstrapi {
	    globalModule {
            news_details {
                Get_Started_Content
                Get_Started_CTA_1_Label
                Get_Started_CTA_2_Label
                Get_Started_CTA_2_Link {
              URL
              id
              Link_Type
            }
               Get_Started_CTA_1_Link {
              URL
              id
              Link_Type
            }
                image {
                  url
                }
                Title
                id
                _id
            }
        Get_Started_Content
        Get_Started_CTA_1_Label
        Get_Started_CTA_2_Label
        Get_Started_CTA_1_Link {
              URL
              id
              Link_Type
            }
            Get_Started_CTA_2_Link {
              URL
              id
              Link_Type
            }
	    }
        siteConfig {
			Address
			Email
			Phone
			Available_Timings
		  }
      }
    }
  `);



    const content = data.glstrapi.globalModule
    //console.log(content.news_details, 'content')

    const ctaAction = (type, label, action) => {
        //console.log(action,'action');
        var cls = "btn btn-primary";
        if (type === 2) {
            cls = "btn btn-secondary";
        }
        if (action === "Banner_Search") {
            return <Button className={`${cls} banner_search`}>{label}</Button>
        } else if (action === "Request_Callback") {
            return <a href="javascript:void(0)" className={`${cls} max-width-high`} onClick={openBookViewformModal}>{label}</a>
        } else if (action === "Request_Valuation") {
            return <a href="javascript:void(0)" className={`${cls} max-width-high`} onClick={openValuationformModal}>{label}</a>
        } else if (action === "Book a valuation") {
            return <button class="btn btn-primary contact-book-btn" onClick={openBookViewformModal}>{label}</button>
        }
    };

    const ctaLink = (type, label, link) => {
        var cls = "btn btn-primary";
        if (type === 2) {
            cls = "btn btn-secondary";
        }
        if (link.Link_Type === "Internal") {
            return <Link to={`/${GetURL(link.id)}`} className={cls}>{label}</Link>
        } else if (link.Link_Type === "External") {
            return <a href={`${GetURL(link.id)}`} target="_blank" className={cls}>{label}</a>
        }
    };
    const openBookViewformModal = () => {
        setBookViewingformOpen(true);
    };
    const closeBookViewformModal = () => {
        setBookViewingformOpen(false);
    };

    const [modalValuationformOpen, setValuationformOpen] = React.useState(false);
    const openValuationformModal = () => {
        setValuationformOpen(true);
    };
    const closeValuationformModal = () => {
        setValuationformOpen(false);
    };
    const image_url = content?.news_details?.image[0]?.url;
    const image_url1 = content.news_details.image[0].url;

    return (
        <React.Fragment>
            <div className="footer-block contact">
                <Container fluid={isCustomMin}>
                    <Row>
                        <Col lg={7} className="d-flex px-0 block-left">
                            <div className="contact-us">
                                {content.news_details.Title && <h4>{content.news_details.Title}</h4>}
                                {content.news_details &&
                                    <div className="footer-block-text text-sm">{HTMLReactParser(content.news_details.Get_Started_Content.replace(/<br\s*\/?>/gi, ''))}</div>
                                }
                                <div className="btn-wrapper">
                                    
                                    {content.news_details.Get_Started_CTA_1_Label && content.news_details.Get_Started_CTA_1_Link && content.news_details.Get_Started_CTA_1_Label !== "Book a valuation" &&
                                        ctaLink(1, content.news_details.Get_Started_CTA_1_Label, content.news_details.Get_Started_CTA_1_Link)
                                    }
                                    {content.news_details.Get_Started_CTA_1_Label && content.news_details.Get_Started_CTA_1_Label &&
                                        ctaAction(1, content.news_details.Get_Started_CTA_1_Label, content.news_details.Get_Started_CTA_1_Label)
                                    }
                                    {content.news_details.Get_Started_CTA_2_Label && content.news_details.Get_Started_CTA_2_Link &&
                                        ctaLink(2, content.news_details.Get_Started_CTA_2_Label, content.news_details.Get_Started_CTA_2_Link)
                                    }
                                    {content.news_details.Get_Started_CTA_2_Label && content.news_details.Get_Started_CTA_1_Label &&
                                        ctaAction(2, content.news_details.Get_Started_CTA_2_Label, content.news_details.Get_Started_CTA_2_Label)
                                    }
                                </div>
                            </div>
                        </Col>
                        <Col lg={5} className="p-0 d-none d-lg-flex block-right">
                            <div className="block-image">
                                <img
                                    src={image_url} // Directly set the image source URL
                                />
                            </div>

                        </Col>
                    </Row>
                    <ModalTiny show={modalBookViewformOpen} onHide={closeBookViewformModal} className="modal-form-wrapper form-viewing-wrapper">
				<ModalTiny.Header>
				<div class="modal-close-btn" onClick={closeBookViewformModal}><CloseIcon /></div>
				<ModalTiny.Title>
					<h4>Book an Valuation</h4>
				</ModalTiny.Title>
				</ModalTiny.Header>
				<ModalTiny.Body>
				<ValuationFormPage
					property_img={``}
					property_id={''}
					page_url={null}
					property_title={''}
					negotiator={''} />
				</ModalTiny.Body>
			</ModalTiny>    
                </Container>
            </div>
        </React.Fragment>
    )
}
export default NewsStaticContact